export interface IProductFeature {
    id: number;

    title: string;

    description: string[];

    price: number;
}

export class AvailableProduct {
    id: string;

    title: string;

    price: number;

    installmentPrice?: number | undefined;

    features?: IProductFeature[] | undefined;

    get featuresPrice() {
        return this.features.reduce((acc, curr) => {
            acc += curr.price;
            return acc;
        }, 0);
    }
}

export class CreditCard {
    flag: string;

    digits: string;

    number: string;

    expirationMonth: string;

    expirationYear: string;

    securityCode: string;

    ownerName: string;
}

export interface IOrderBumpState {
    loading: boolean;

    loadingCustomerInfo: boolean;

    paymentMethod: number | undefined;

    creditCard: CreditCard | undefined;

    discount: number | undefined;

    discountVoucher: string | undefined;

    availableProducts: AvailableProduct[];

    selectedProducts: AvailableProduct[];

    selectedProductIds: string[];

    price: number | undefined;

    total: number;

    installmentTotal: number;

    maxNumberOfInstallments: number;
}
